module.exports = __webpack_public_path__ + "img/3.d44661a3.jpg";